

import Show from "./components/show"
import Festival from "./components/festival"
import ShowPreview from "./components/show-preview"

let sponsors = [
    {
        name: "Mountain Health",
        level: 1,
    },
    {
        name: "Cabell Huntington Hospital",
        level: 1,
    },
    {
        name: "St. Mary’s Medical Center",
        level: 1,
    },        
    {
        name: "Encova",
        level: 2,
    },
    {
        name: "Cabell County Commission",
        level: 2,
        text: true,
    },
    {
        name: "WV Division of Arts, Culture and History",
        level: 2,
    },
    {
        name: "WV Lottery",
        level: 2,
    },
    {
        name: "Farrell White and Legg",
        level: 2,
    },
    {        
        name: "NRP",
        level: 3,
    },
    {        
        name: "Agee Foundation",
        level: 3
    },        
    {
        name: "CJ Hughes",
        level: 4
    },
    {
        name: "David and Kim Robinson",
        level: 4,
        text: true,
    },
    {
        name: "Steptoe & Johnson",
        level: 4,
    },
    {
        name: "Dutch Miller",
        level: 4,
    },
    {
        name: "ZMM",
        level: 4,
    },
    {
        name: "City National Bank",
        level: 4,
    },    
    {
        name: "Marshall Health",
        level: 4,
    }, 

    {
        name: "The Touma Foundation",
        level: 5,
    },
    {
        name: "Marshall Orthopaedics",
        level: 5,
    },
    {
        name: "Huntington Federal",
        level: 5,
    },
    {
        name: "The Chirico Family",
        level: 5,
        text: true
    },

    
    {
        name: "Air Systems Inc.",
        level: 6,
    },
    {        
        name: "Neighborgall Construction",
        level: 6,
    },    
    {
        name: "Boggs Roofing",
        level: 6,
    },    
    {
        name: "Community Trust Bank",
        level: 6,
    },   
    {
        name: "CVB",
        level: 6,
    },        
    {
        name: "Dr. Daivd & Mrs. Sharon Denning",
        level: 6,
        text: true,
    },
    
    {
        name: "Dr Christopher & Mrs. Tammy Hugh",
        level: 7,
        text: true,
    },
    {
        name: "Reger Funeral Home",
        level: 7,
    },
    {        
        name: "Baird", level: 7
    },         
    {        
        name: "Summit Bank", level: 7
    }, 

    {        
        name: "Sammons-Adams Orthodontics",
        level: 8,
    },
    {        
        name: "Marsha Slater State Farm Insurance",
        level: 9,
        text: true,
    },
    {        
        name: "Dr Stephen Nicholas",
        level: 9,
        text: true,
    },

    {        
        name: "21 The Frederick", level: 10,
    },
    {        
        name: "Rocco's", level: 10,
    },
    {        
        name: "Gino's", level: 10,
    },
    {        
        name: "La Famiglia", level: 10,
    },
    {        
        name: "President Brad and First Lady Alys Smiths", level: 10, text: true,
    },
    {        
        name: "Society of Yeager Scholars at Marshall University", level: 10, text: true,
    },   
]

for (let sponsor of sponsors) {
    //sponsor.logo = process.env.PUBLIC_URL + "/shows/" + show.name + "/poster.jpg?v2";
}

export function getAllSponsors() {
    return sponsors;
}

export function getShowSponsors(showName) {
    return sponsors.find(s => s.shows && s.shows.indexOf(showName) != -1);
}